// source: pbtypes/gen/calibration/camera_undistortion.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_calibration_rotation_mode_pb = require('../../../pbtypes/gen/calibration/rotation_mode_pb.js');
goog.object.extend(proto, pbtypes_gen_calibration_rotation_mode_pb);
var pbtypes_gen_calibration_scaling_mode_pb = require('../../../pbtypes/gen/calibration/scaling_mode_pb.js');
goog.object.extend(proto, pbtypes_gen_calibration_scaling_mode_pb);
var pbtypes_gen_eigen_lcm_Vector2d_pb = require('../../../pbtypes/gen/eigen_lcm/Vector2d_pb.js');
goog.object.extend(proto, pbtypes_gen_eigen_lcm_Vector2d_pb);
goog.exportSymbol('proto.calibration.CameraUndistortion', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.calibration.CameraUndistortion = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.calibration.CameraUndistortion, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.calibration.CameraUndistortion.displayName = 'proto.calibration.CameraUndistortion';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.calibration.CameraUndistortion.prototype.toObject = function(opt_includeInstance) {
  return proto.calibration.CameraUndistortion.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.calibration.CameraUndistortion} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.calibration.CameraUndistortion.toObject = function(includeInstance, msg) {
  var f, obj = {
focalScales: (f = msg.getFocalScales()) && pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb.toObject(includeInstance, f),
rotationMode: jspb.Message.getFieldWithDefault(msg, 2, 0),
scalingMode: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.calibration.CameraUndistortion}
 */
proto.calibration.CameraUndistortion.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.calibration.CameraUndistortion;
  return proto.calibration.CameraUndistortion.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.calibration.CameraUndistortion} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.calibration.CameraUndistortion}
 */
proto.calibration.CameraUndistortion.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb;
      reader.readMessage(value,pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb.deserializeBinaryFromReader);
      msg.setFocalScales(value);
      break;
    case 2:
      var value = /** @type {!proto.calibration.RotationMode.Enum} */ (reader.readEnum());
      msg.setRotationMode(value);
      break;
    case 3:
      var value = /** @type {!proto.calibration.ScalingMode.Enum} */ (reader.readEnum());
      msg.setScalingMode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.calibration.CameraUndistortion.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.calibration.CameraUndistortion.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.calibration.CameraUndistortion} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.calibration.CameraUndistortion.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFocalScales();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb.serializeBinaryToWriter
    );
  }
  f = message.getRotationMode();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getScalingMode();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional eigen_lcm.Vector2dPb focal_scales = 1;
 * @return {?proto.eigen_lcm.Vector2dPb}
 */
proto.calibration.CameraUndistortion.prototype.getFocalScales = function() {
  return /** @type{?proto.eigen_lcm.Vector2dPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb, 1));
};


/**
 * @param {?proto.eigen_lcm.Vector2dPb|undefined} value
 * @return {!proto.calibration.CameraUndistortion} returns this
*/
proto.calibration.CameraUndistortion.prototype.setFocalScales = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.calibration.CameraUndistortion} returns this
 */
proto.calibration.CameraUndistortion.prototype.clearFocalScales = function() {
  return this.setFocalScales(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.calibration.CameraUndistortion.prototype.hasFocalScales = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional RotationMode.Enum rotation_mode = 2;
 * @return {!proto.calibration.RotationMode.Enum}
 */
proto.calibration.CameraUndistortion.prototype.getRotationMode = function() {
  return /** @type {!proto.calibration.RotationMode.Enum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.calibration.RotationMode.Enum} value
 * @return {!proto.calibration.CameraUndistortion} returns this
 */
proto.calibration.CameraUndistortion.prototype.setRotationMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional ScalingMode.Enum scaling_mode = 3;
 * @return {!proto.calibration.ScalingMode.Enum}
 */
proto.calibration.CameraUndistortion.prototype.getScalingMode = function() {
  return /** @type {!proto.calibration.ScalingMode.Enum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.calibration.ScalingMode.Enum} value
 * @return {!proto.calibration.CameraUndistortion} returns this
 */
proto.calibration.CameraUndistortion.prototype.setScalingMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


goog.object.extend(exports, proto.calibration);
